var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 16,
    fill: "url(#paint0_linear_15263_36569)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 15H17C15.8954 15 15 15.8954 15 17V33C15 34.1046 15.8954 35 17 35H21C22.1046 35 23 34.1046 23 33V17C23 15.8954 22.1046 15 21 15ZM17 13C14.7909 13 13 14.7909 13 17V33C13 35.2091 14.7909 37 17 37H21C23.2091 37 25 35.2091 25 33V17C25 14.7909 23.2091 13 21 13H17ZM33 15H30C28.8954 15 28 15.8954 28 17V20C28 21.1046 28.8954 22 30 22H33C34.1046 22 35 21.1046 35 20V17C35 15.8954 34.1046 15 33 15ZM30 13C27.7909 13 26 14.7909 26 17V20C26 22.2091 27.7909 24 30 24H33C35.2091 24 37 22.2091 37 20V17C37 14.7909 35.2091 13 33 13H30ZM30 28H33C34.1046 28 35 28.8954 35 30V33C35 34.1046 34.1046 35 33 35H30C28.8954 35 28 34.1046 28 33V30C28 28.8954 28.8954 28 30 28ZM26 30C26 27.7909 27.7909 26 30 26H33C35.2091 26 37 27.7909 37 30V33C37 35.2091 35.2091 37 33 37H30C27.7909 37 26 35.2091 26 33V30Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15263_36569",
    x1: 50,
    y1: 0.00000160187,
    x2: -3.75,
    y2: 55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E4AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443569,
    stopColor: "#10C5E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9240DC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardActive);
export default __webpack_public_path__ + "static/media/dashboard-active.779c4139d88fb61330e5cbf75679b5d8.svg";
export { ForwardRef as ReactComponent };